import React from "react";
import { Table, TableHead, TableCell, TableRow, TableBody } from "@material-ui/core";
import { Values } from "Tools/Values";
import PersonTableItem from "./PersonTableItem/PersonTableItem";
import { STPaper } from "@src/Components/Ui/STPaperOverflow";
import { STTableHeadTypography } from "@src/Components/Ui/STTableHeadTypography";
import { Person } from "@src/Interfaces/Entity/Person";
import { inject } from "mobx-react";
import { IAuthStore } from "@src/Stores/Auth/types";

interface IProps {
  persons: Person[];
  auth?: IAuthStore;
  onEditPersonClick?: (person: Person) => void;
}

@inject("auth")
export default class PersonsTable extends React.Component<IProps> {
  render() {
    return (
      <STPaper elevation={2}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <STTableHeadTypography>{Values.getLocalizationValue("name")}</STTableHeadTypography>
              </TableCell>
              <TableCell>
                <STTableHeadTypography>{Values.getLocalizationValue("fullName")}</STTableHeadTypography>
              </TableCell>
              <TableCell>
                <STTableHeadTypography>{Values.getLocalizationValue("email")}</STTableHeadTypography>
              </TableCell>
              <TableCell>
                <STTableHeadTypography>{Values.getLocalizationValue("lastActivePosition")}</STTableHeadTypography>
              </TableCell>
              <TableCell>
                <STTableHeadTypography>{Values.getLocalizationValue("lastActiveLocation")}</STTableHeadTypography>
              </TableCell>
              <TableCell>
                <STTableHeadTypography>{Values.getLocalizationValue("activePosition")}</STTableHeadTypography>
              </TableCell>
              {!this.props.auth.user.location.primary && (
                <TableCell>
                  <STTableHeadTypography>{Values.getLocalizationValue("assignedPosition")}</STTableHeadTypography>
                </TableCell>
              )}
              <TableCell align="right" />
            </TableRow>
          </TableHead>
          <TableBody>
            {this.props.persons.map((person: Person) => {
              return <PersonTableItem
                  onEditClick={this.props.onEditPersonClick}
                  key={person.id}
                  person={person}
              />;
            })}
          </TableBody>
        </Table>
      </STPaper>
    );
  }
}
